import React from 'react';
import './styles.scss';

const Landing: React.FC = () => {
  return (
    <div className="container gx-md-3 gx-sm-2 work-container">
      <section className="hero-section pt-5 mt-5">
        <div className="row">
          <div className="col-md-11">
            <h1 className="display-3 fw-normal mb-4">
            I used to work in trading; now I build full-stack software for startups. I focus on creating lightweight and capable applications.
            </h1>
          </div>
        </div>
      </section>

      <section className="my-5 py-5">
        <div className="row">
          <h2 className="display-4 mb-4">Companies I've worked with</h2>
        </div>
        <div className="text-center">
          <div className="company-logos">
            <div className="logo-item">
              <img src="/assets/Logos/PacerLogo.png" alt="Pacer" className="company-logo" />
            </div>
            <div className="logo-divider"></div>
            <div className="logo-item">
              <img src="/assets/Logos/CTILogo.png" alt="CTI" className="company-logo" />
            </div>
            <div className="logo-divider"></div>
            <div className="logo-item">
              <img src="/assets/Logos/WellingtonLogo.jpg" alt="Wellington" className="company-logo" />
            </div>
            <div className="logo-divider"></div>
            <div className="logo-item">
              <img src="/assets/Logos/sllogo_black.png" alt="Spectra Logic" className="company-logo" />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Landing;
